import { Component, OnInit, TemplateRef } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { FormBuilder } from '@angular/forms';
import { SWAlertService } from '../../services/swalert.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TSFuntionService } from '../../services/ts-funtion.service';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead/typeahead-match.class';
import * as _ from 'lodash';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
@Component({
  selector: 'app-report-rejected',
  templateUrl: './report-rejected.component.html',
  styleUrls: ['./report-rejected.component.css']
})
export class ReportRejectedComponent implements OnInit {
  data: any;
  txtstatus: any[] = [];
  arrCompany: any[] = [];
  arrPaytype: any[] = [];
  arrTreq: any[] = [];
  arrStatus: any[] = [];
  settings_PayType = {};
  settings_com = {};
  settings_Status = {};
  txtPaytype: any[] = [];
  txtCom: any[] = [];
  sCom: any[] = [];
  status: any[] = [];
  sPaytype: any[] = [];
  IsCom: any[] = [];
  IsPaytype: boolean = false;
  txtrangDate: any[] = [];
  txtrangReDate: any[] = [];
  txtrangSoDate: any[] = [];
  IsReqNo1: boolean = false;
  IsReqNo2: boolean = false;
  txtReqNo1: string = null;
  txtReqNo2: string = null;
  sReqNo1: string = null;
  sReqNo2: string = null;
  modalRef: BsModalRef;
  minDate: Date = new Date();
  maxDate: Date = new Date();
  OptionGrid = {
    nCurrentPage: 1,
    maxSize: 7,
    nPageSize: 10,
    nTotalItem: 0,
    ArrPageSize: [
      { sValue: 10 },
      { sValue: 20 },
      { sValue: 50 },
      { sValue: 100 }
    ]
  }
  _ArrData: any;
  _ArrDatatotal: any[] = [];
  _ArrDatatotalBind: any[] = [];
  //Set grid
  _ArrDataBind = [];
  sDetailData = "";
  IsHeaderSort = "";
  SortDirection = "";
  SortICO = "fas fa-sort";
  IcoSort = "fas fa-sort";
  IcoSortAsc = "fas fa-sort-up";
  IcoSortDesc = "fas fa-sort-down";
  //Head colums
  Columns = [
    { ColumnName: "Request No. ", SortField: "sRequestCode", Width: "110px" },
    { ColumnName: "Request Date ", SortField: "dRequestDate", Width: "120px" },
    { ColumnName: "Status ", SortField: "sStatusName_SSC", Width: "140px" },
    { ColumnName: "Due Date ", SortField: "dDueDate", Width: "100px" },
    { ColumnName: "Vendor Name ", SortField: "VENDORNAME", Width: "150px" },
    { ColumnName: "Payment Type ", SortField: "sReqType", Width: "130px" },
    { ColumnName: "Currency ", SortField: "sCurrency", Width: "100px" },
    { ColumnName: "Amount excl. VAT ", SortField: "nGrandTotalAmt", Width: "140px" },
    { ColumnName: "VAT ", SortField: "nGrandTotalAmtVat", Width: "100px" },
    { ColumnName: "Amount incl. VAT ", SortField: "nGrandTotalAmtInvoice", Width: "140px" },
    { ColumnName: "Description ", SortField: "Desc", Width: "150px" },
    { ColumnName: "Rejected Date ", SortField: "dApprove", Width: "130px" },
    { ColumnName: "Requester", SortField: "fullname", Width: "200px" },
    { ColumnName: "Rejected Comment ", SortField: "sComment", Width: "150x" },
    { ColumnName: "Resolved Date ", SortField: "dResolveDate", Width: "130px" },
    { ColumnName: "History Log ", SortField: "", Width: "5px" },
  ]
  constructor(private http: HttpClient
    , private formBuilder: FormBuilder
    , private SW: SWAlertService
    , private activatedRoute: ActivatedRoute
    , private router: Router
    , private System: TSFuntionService
    , private modalService: BsModalService) { }

  ngOnInit() {
    this.getAutocomplete();
    this.settings_PayType = {
      singleSelection: false,
      idField: 'nReqType',
      textField: 'sReqType',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      maxHeight: 197,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Data',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };

    this.settings_com = {
      singleSelection: false,
      idField: 'COMPANY_CODE',
      textField: 'COMPANY_NAME',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      maxHeight: 197,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Data',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };

    this.settings_Status = {
      singleSelection: false,
      idField: 'nStatusID',
      textField: 'sStatusName_SSC',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      maxHeight: 197,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Data',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };

    const ua = this.System.GetUserStorage();
    if (ua) {
      this.txtCom = [];
      this.sCom = [];
      ua.lstCompCode.forEach(f =>
        {
          this.txtCom.push({COMPANY_CODE: f.sCompCode, COMPANY_NAME: f.sCompName})
          this.sCom.push(f.sCompCode)
        }
      );
    }

    let nsize = document.getElementById('dvbtn').offsetWidth;
    let width = "width:" + nsize + "px";
    document.getElementById('dvtable2').setAttribute("style", width);
    document.getElementById('tbExample').setAttribute("style", "width:2100px");
    this.minDate.setDate(this.minDate.getDate() - 90);
    this.maxDate.setDate(this.maxDate.getDate());
    this.txtrangDate = [this.minDate, this.maxDate];
    //this.txtrangReDate = [this.minDate, this.maxDate];
    //this.txtrangSoDate = [this.minDate, this.maxDate];
  }

  async getAutocomplete() {
    this.System.BlockUI();
    await this.http.get<any>(this.System.SiteName + "api/Reject_T_History/getAutoData").toPromise().then(res => {
      this.data = res;
      const ua = this.System.GetUserStorage();
      if ([3, 4, 5].includes(ua.nRole)) {
        this.arrCompany = this.data.lstCompany.filter(f => f.COMPANY_CODE === ua.sCompCode);
      }
      else {
        this.arrCompany = this.data.lstCompany;
      }
      
      this.arrPaytype = this.data.lstPayType;
      this.arrTreq = this.data.lstTreq;
      this.arrStatus = JSON.parse(this.data.lstStatus);
      this.txtstatus = this.arrStatus.filter(f => f.nStatusID == 10);
      this.status = this.txtstatus.map(m => m.nStatusID);
    });
    this.System.UnBlockUI();
  }

  //onselectpaytype(item: any) {
  //  if (this.txtPaytype) {
  //    let npaytype = this.txtPaytype.map(f => Number.parseInt(f.nReqType))
  //    this.arrTreq = this.data.lstTreq.filter(function (index) { return npaytype.includes(index.nReqType) });
  //    if (this.txtCom) {
  //      this.arrTreq = this.arrTreq.filter(f => f.sCompCode == this.sCom);
  //    }
  //  }
  //}

  onselectpaytype(item: any, name: any) {
    let _this = this;
    if (name == 'txtPaytype') {
      let npaytype = this.txtPaytype.map(f => Number.parseInt(f.nReqType))
      this.arrTreq = this.data.lstTreq.filter(function (index) { return npaytype.includes(index.nReqType) });
      if (this.txtCom.length != 0) {
        this.sCom = this.txtCom.map(f => f.COMPANY_CODE)
        this.arrTreq = this.data.lstTreq.filter(function (index) { return _this.sCom.includes(index.sCompCode) });
      }
    }
    if (name == 'txtCom') {
      this.sCom = this.txtCom.map(f => f.COMPANY_CODE)
      this.arrTreq = this.data.lstTreq.filter(function (index) { return _this.sCom.includes(index.sCompCode) });
    }
    if (name == 'txtstatus') {
      this.status = this.txtstatus.map(f => f.nStatusID);
    }
  }

  onSelectAll(item: any, name: any) {
    let _this = this;
    if (name == 'txtCom') {
      this.sCom = item.map(f => f.COMPANY_CODE)
      this.arrTreq = this.data.lstTreq.filter(function (index) { return _this.sCom.includes(index.sCompCode) });
    }
    if (name == 'txtPaytype') {
      let npaytype = item.map(f => Number.parseInt(f.nReqType))
      this.arrTreq = this.data.lstTreq.filter(function (index) { return npaytype.includes(index.nReqType) });
    }
    if (name == 'txtstatus') {
      this.txtstatus = this.arrStatus;
      this.status = this.txtstatus.map(f => f.nStatusID);
    }
  }

  DeSelect(item: any, name: any) {
    let _this = this;
    if (name == 'txtCom') {
      let com = item.COMPANY_CODE
      this.sCom = this.sCom.filter(function (index) { return !com.includes(index) });
      this.arrTreq = this.data.lstTreq.filter(function (index) { return _this.sCom.includes(index.sCompCode) });
    }
    if (name == 'txtPaytype') {
      let npaytype = item.nReqType
      this.arrTreq = this.data.lstTreq.filter(function (index) { return !npaytype.includes(index.nReqType) });
    }
    if (name == 'txtstatus') {
      this.status = this.txtstatus.map(f => f.nStatusID);
    }
  }

  onDeSelectAll(item: any, name: any) {
    let _this = this;
    if (name == 'txtCom') {
      this.sCom = []
    }
    if (name == 'txtPaytype') {
      this.txtPaytype = [];
    }
    if (name == 'txtstatus') {
      this.txtstatus = [];
      this.status = [];
    }
    this.arrTreq = this.data.lstTreq;
  }

  typeaheadNoResults(event, index) {
    switch (index) {
      case "txtCom":
        this.IsCom = event;
        break
      case "txtPreparer":
        this.IsPaytype = event;
        break
      case "txtReqNo1":
        this.IsReqNo1 = event;
        break
      case "txtReqNo2":
        this.IsReqNo2 = event;
        break
    }
  }

  typeaheadOnBlur(event: TypeaheadMatch, index) {
    var pass = true
    switch (index) {
      case "txtCom":
        if (this.txtCom != event.item.COMPANY_NAME) {
          pass = false
        }
        if (pass) {
          this.onSelect(event, index)
        } else {
          this.txtCom = null;
          this.sCom = null;
        }
        break
      case "txtPreparer":
        if (this.IsPaytype) {
          this.txtPaytype = null;
        }
        if (this.txtPaytype.length != 0) {
          this.txtPaytype = [];
          this.sPaytype = [];
        }
        break
      case "txtReqNo1":
        if (this.txtReqNo1 != event.item.sRequestCode) {
          pass = false
        }
        if (pass) {
          this.onSelect(event, index);
        } else {
          this.txtReqNo1 = null;
          this.sReqNo1 = null;
        }

        break
      case "txtReqNo2":
        if (this.txtReqNo2 != event.item.sRequestCode) {
          pass = false
        }
        if (pass) {
          this.onSelect(event, index);
        } else {
          this.txtReqNo2 = null;
          this.sReqNo2 = null;
        }

        break

    }
  }
  onSelect(event: TypeaheadMatch, index) {
    switch (index) {
      case "txtCom":
        this.sCom = event.item.COMPANY_CODE;
        this.arrTreq = this.arrTreq.filter(f => f.sCompCode == this.sCom);
        break
      case "txtReqNo1":
        this.sReqNo1 = event.item.sRequestCode;
        break
      case "txtReqNo2":
        this.sReqNo2 = event.item.sRequestCode;
        break
    }
  }

  Onsearch() {
    this.System.BlockUI();
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    })
    let arrType = this.txtPaytype.map(f => f.nReqType)
    let data = {
      arrComcode: this.sCom
      , sReqNo1: this.sReqNo1
      , sReqNo2: this.sReqNo2
      , arrpaytype: arrType
      , RangDate: this.txtrangDate
      , RangReDate: this.txtrangReDate
      , RangSoDate: this.txtrangSoDate
      , arrStatus: this.status
    }
    let ITEM = JSON.stringify(data)
    this._ArrData = [];
    this._ArrDatatotalBind = [];
    this.http.post(this.System.SiteName + 'api/Reject_T_History/searchData', ITEM, { headers, responseType: 'json' }).subscribe(res => {
      var data = res == null ? [] : res;
      this._ArrData = data;
      this.OptionGrid.nCurrentPage = 1;
      this.BindDataTable();
      this.System.UnBlockUI();
    });
  }

  BindDataTable() {
    this.OptionGrid.nTotalItem = this._ArrData.length;

    let nStartIndex_Take = (this.OptionGrid.nCurrentPage - 1) * this.OptionGrid.nPageSize;
    let nEndIndex_Take = this.OptionGrid.nPageSize;
    this._ArrDataBind = [];
    this._ArrData.forEach(val => this._ArrDataBind.push(Object.assign({
      sReqUG: val.IsReqUrgent == true ? "UG" : null
      , sUG: val.IsSSCUrgent == true ? "UG" : null
    }, val)));
    this._ArrDataBind = this._ArrDataBind.splice(nStartIndex_Take, nEndIndex_Take);

    let nStartItemPage = nStartIndex_Take + 1;
    let nLastItemPage = nStartIndex_Take + this._ArrDataBind.length;
    this.sDetailData = "Showing " + nStartItemPage + " to " + nLastItemPage + " of " + this._ArrData.length + " Rows";
  }

  //#region Event
  //Event ตอนกด Click Header
  SortHeaderClick(ColumnName: string, SortField: string) {
    if (ColumnName) {
      if (ColumnName === this.IsHeaderSort) {
        this.SortDirection = this.SortDirection === 'asc' ? 'desc' : 'asc';
        this.SortICO = (this.SortDirection === 'asc') ? this.IcoSortAsc : this.IcoSortDesc;
      }
      else {
        this.SortICO = this.IcoSortAsc;
        this.SortDirection = 'asc';
      }
      this.IsHeaderSort = ColumnName;
      this._ArrData = _.orderBy(this._ArrData, [SortField], [this.SortDirection]);
      this.BindDataTable();
    }
  }

  PageSizeChange() {
    setTimeout(() => {
      this.OptionGrid.nCurrentPage = 1;
      this.BindDataTable();
    });

  }

  PageChanged(event: any) {
    this.OptionGrid.nCurrentPage = event.page;
    this.BindDataTable();
  }

  //#endregion

  ExportExcel() {
    const link = document.createElement('a');
    link.target = '_blank'
    link.href = this.System.SiteName + "api/Reject_T_History/CreateReportExpected";
    link.setAttribute('visibility', 'hidden');
    link.click();
  }

  OnClear() {
    this.txtCom = [];
    this.txtReqNo1 = null;
    this.txtReqNo2 = null;
    this.txtPaytype = [];
    this.txtrangDate = [];
    this.txtrangReDate = [];
    this.txtrangSoDate = [];
    this._ArrDataBind = [];
    this._ArrDatatotalBind = [];
    this.sCom = [];
    this.sReqNo1 = null;
    this.sReqNo2 = null;
    this.txtrangDate = [this.minDate, this.maxDate];
    this.txtstatus = [];
    this.status = [];
    const ua = this.System.GetUserStorage();
    if (ua) {
      ua.lstCompCode.forEach(f =>
        {
          this.txtCom.push({COMPANY_CODE: f.sCompCode, COMPANY_NAME: f.sCompName})
          this.sCom.push(f.sCompCode)
        }
      );
    }
  }

  sReqID: any;
  ArrTran: any[] = [];
  openModal(template: TemplateRef<any>, sReqID: any) {
    this.sReqID = sReqID;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set('sReqID', sReqID)
    };
    this.http.get<any>(this.System.SiteName + "api/Reject_T_History/GetLog", httpOptions).subscribe(res => {
      if (res) {
        this.ArrTran = res;
        this.modalRef = this.modalService.show(
          template,
          Object.assign({}, { class: 'gray modal-lg' })
        );
      }

    })

  }
}
